import { Injectable } from "@angular/core";
import { AuthProvider } from "../auth/auth";
import { AppConfig } from "../../config/app.config";
import { Category } from "../../models/category";
import { DataProvider } from "../data/data";
import { Headers, URLSearchParams } from '@angular/http';

const ROUTE = 'categories';

@Injectable()
export class CategoryProvider extends DataProvider<Array<Category>>{

    constructor() {
        super(ROUTE);
    }

    private categories: Array<Category>;

    public async getCategories(): Promise<Array<Category>> {
        // if (!this.categories) {
        //     this.categories = this.auth.get(ROUTE).then(x => x as Array<Category>);
        // }
        // return this.categories;
        return await this.auth.get(ROUTE).then(x => x as Array<Category>);
    }

    public async getCategory(uuid: string): Promise<Category> {
        return this.getCategories().then(x => x.find(cat => cat.uuid == uuid));
    }
}


// WEBPACK FOOTER //
// ./src/providers/category/category.ts